import { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import ImageModal from '../../attachImages/ImageModal';
import { ICampaignDeliverables } from '../../../interfaces/campaign.interface';

interface IProps {
    deliverable: ICampaignDeliverables;
    updateDeliverableUserProductPhoto: (userProductPhoto: string) => void;
}

const AttachProductImage = ({
    deliverable,
    updateDeliverableUserProductPhoto: updateDeliverableProductImageUrl,
}: IProps) => {
    const [showModal, setShowModal] = useState(false);

    const onHide = () => {
        setShowModal(false);
    };
    const onShow = () => {
        setShowModal(true);
    };
    const onRemoveImage = () => {
        updateDeliverableProductImageUrl('');
    };
    const onUpload = (imageUrl: string) => {
        updateDeliverableProductImageUrl(imageUrl);
        onHide();
    };

    return (
        <>
            {deliverable.user_product_path && deliverable.user_product_path.length > 0 ? (
                <div className="productImage-deliverable">
                    <div className="productImage-img">
                        <Image
                            src={deliverable.user_product_path}
                            fluid
                            style={{ width: '3rem', height: '3rem' }}
                        />
                        <button className="close" onClick={onRemoveImage}>
                            <i className="ph-bold ph-prohibit-inset"></i>
                        </button>
                    </div>
                </div>
            ) : (
                <div
                    onClick={onShow}
                    className="tw-border tw-rounded-md tw-border-gray-250 tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-x-1 tw-cursor-pointer hover:tw-bg-gray-200"
                >
                    <i className="ph ph-image lg"></i>
                    <div className="tw-hidden xl:tw-block tw-whitespace-nowrap">Change Image</div>
                </div>
            )}
            <ImageModal show={showModal} onHide={onHide} onUpload={onUpload} />
        </>
    );
};

export default AttachProductImage;
